export default {
  tableRowColumn: {
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 10,
    paddingBottom: 10,
    height: 20,
    fontSize: 14,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    wordBreak: 'break-all',
    textOverflow: 'ellipsis'
  },
  tableRow: {
    borderBottom: '1px solid #eee',
    color: '#000',
    textAlign: 'left',
  },
  tableRowHover: {
    background: '#eee'
  },
  tableRowCenter: {
    textAlign: 'center'
  },
  table: {
    backgroundColor: '#fff',
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    tableLayout: 'fixed',
  },
  TableHeader: {},
  TableHeaderRowColumn: {
    textAlign: 'center'
  },
  tableWrapper: {
    overflowX: 'auto'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Table/style.js